import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStoreService {
  private ls = window.localStorage;
  private isLsChanged = new Subject<boolean>();

  constructor() {}

  public setItem(key, value) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  public getItem(key) {
    const value = this.ls.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public removeItem(key) {
    this.ls.removeItem(key);
    return true;
  }

  public clear() {
    this.ls.clear();
  }

  public changeLs(message: boolean) {
    this.isLsChanged.next(message);
  }

  public getLsChanges(): Observable<any> {
    return this.isLsChanged.asObservable();
  }
}
